import React, { Component } from "react";
import { connect } from "react-redux";
import { View, Text } from "react-native";

import { Navigator } from "router";
import { Modal, Button } from "components";

import { getError } from "state/modules/error";
import { logout, refreshToken } from "state/modules/taker";
import { POST_TOKEN } from "state/modules/taker/types";

import { styles } from "./styles";

export class BaseTokenCheck extends Component {
  componentDidMount = () => {
    this.props.refreshToken();
  };

  redirect = () => {
    const { logout } = this.props;
    logout();
    Navigator.jumpTo("login");
  };

  render = () => (
    <Modal visible={!!this.props.message}>
      <View style={styles.modal}>
        <Text style={styles.text}>{this.props.message}</Text>
        <Button color="black" text="Okay" onPress={this.redirect} />
      </View>
    </Modal>
  );
}

const mapDispatchToProps = {
  logout,
  refreshToken,
};

const mapStateToProps = state => {
  return { message: getError(state, [POST_TOKEN]) };
};

export const TokenCheck = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BaseTokenCheck);
